<template>
  <div class="boci-privacy-wrap">

    <div class="title-wrap">中银保险有限公司车险网络平台隐私政策</div>
    <div class="text-offset-2 top-space">
      中银保险有限公司（以下简称“中银保险”或“我们”）深知个人信息对您的重要性，会尽力保护您的个人信息安全。我们致力于维持您对我们的信任，恪守合法、正当、必要的原则，保护您的个人信息。同时，我们承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。
    </div>
    <div class="text-offset-2">《中银保险有限公司车险网络平台隐私政策》（以下简称“隐私政策”）将帮助您了解以下内容：
    </div>
    <div class="text-offset-2">1.我们如何收集和使用您的个人信息</div>
    <div class="text-offset-2">2.我们如何使用Cookie和同类技术</div>
    <div class="text-offset-2">3.我们如何共享、转让和公开披露您的个人信息</div>
    <div class="text-offset-2">4.我们如何存储和保护您的个人信息</div>
    <div class="text-offset-2">4.相册：经您授权，我们会收集您的相册信息，以便您上传图片、上传视频功能。您可以自行选择开启或关闭相册的授权，一旦关闭您将无法上传图片、上传视频。</div>
    <div class="text-offset-2">5.我们如何实现您个人信息处理活动中的权利</div>
    <div class="text-offset-2">6.我们如何处理未成年人信息</div>
    <div class="text-offset-2">7.本隐私政策的适用以及更新</div>
    <div class="text-offset-2">8.如何联系我们</div>

    <div class="first-wrap">一、我们如何收集和使用您的个人信息</div>
    <div class="text-offset-2">个人信息是以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。<span class="importance">个人信息包括姓名、出生日期、身份证件信息（身份证、护照等）、个人生物识别信息、通信通讯联系方式、住址、账户信息等。</span> 提供我们的车险产品及服务的网络运营平台包括以下主要功能：用户注册、保险产品在线销售功能、保单管理功能、自助理赔功能、承保理赔查询、待续保单续保提醒、短信类服务提醒、邮件类服务提醒、个人设置、电子保单下载、电子发票下载、增值服务、营销活动、保险销售从业人员及相关人员的管理等。我们仅会出于本隐私政策所述的以下目的收集和使用您的个人信息。</div>
    <div class="text-offset-2">（一）您使用核心功能须提供并授权我们使用个人信息的情形</div>
    <div class="text-offset-2">我们的网络运营平台包括一些核心功能，您需要提供并授权我们保存和使用下列与您有关的信息，才能使用这些功能接受服务。如您提供的信息中包含第三方人员信息，默认您已取得第三方人员授权，同意我们对其相关信息进行使用和共享。如您拒绝提供并授权，则无法使用这些核心功能接受服务。具体情形如下：</div>
    <div class="text-offset-2">1．接受在线投保、自助理赔等服务</div>
    <div class="text-offset-2">（1）用户注册</div>
    <div class="text-offset-2">为完成用户注册，您需要提供个人手机号码、验证码等。</div>
    <div class="text-offset-2">（2）车险产品投保</div>
    <div class="text-offset-2">为完成车险产品在线投保功能，您需要提供<span class="importance">所在城市、车牌号码、车辆识别码或车架号、发动机号、初登日期、厂牌型号、车辆种类、使用性质、交强险起止日期、商业险起止日期、投保险种、保险金额、被保险人信息【包括姓名、证件类型、身份证件信息（身份证、护照等）、性别、生日、手机号码、电子邮箱、职业信息】、车主信息【包括姓名、证件类型、身份证件信息（身份证、护照等）、手机号码、电子邮箱】、投保人信息【包括姓名、证件类型、身份证件信息（身份证、护照等）、手机号码、电子邮箱、职业信息】、收件人信息（包括姓名、手机号码、发票抬头）、会员信息（包括手机号码或邮箱）、车辆贷款信息，并上传投保所需资料照片等。</span></div>
    <div class="text-offset-2">（3）意外险产品投保</div>
    <div class="text-offset-2">为完成意外险产品在线投保功能，您需要提供<span class="importance">所在城市、保险方案、保险金额、生效时间、截止时间、被保险人信息【包括姓名、证件类型、身份证件信息（身份证、护照等）、性别、出生日期、与投保人关系、手机号码、职业信息】、投保人信息【包括姓名、证件类型、身份证件信息（身份证、护照等）、手机号码、电子邮箱、性别、职业信息】、车辆信息（车牌号、发动机号、车辆识别码或车架号、座位数、车辆种类、使用性质、初登日期、交强险起止日期、商业险起止日期）等。</span> </div>
    <div class="text-offset-2">（4）保单管理</div>
    <div class="text-offset-2">为完成保单管理功能，您需要提供<span class="importance">手机号码、投保人及被保险人姓名、证件类型、身份证件信息（身份证、护照等）、保单号、生物识别信息、银行卡信息等。</span></div>
    <div class="text-offset-2">（5）自助理赔</div>
    <div class="text-offset-2">为完成自助理赔功能，您需要提供<span class="importance">手机号码、投保人及被保险人姓名、证件类型、身份证件信息（身份证、护照等）、地理位置（位置信息）、银行卡信息、相机（摄像头）、相册（图片库）等。</span> </div>
    <div class="text-offset-2">（6）承保理赔查询</div>
    <div class="text-offset-2">为完成承保理赔查询功能，您需要提供<span class="importance">投保人手机号、投保人姓名、被保险人姓名、被保险人证件类型、身份证件信息（身份证、护照等）、保单号等。</span></div>
    <div class="text-offset-2">（7）增值服务</div>
    <div class="text-offset-2">为完成增值服务相关功能，您需要提供<span class="importance">保单号、手机号码、投保人及被保险人姓名、证件类型、身份证件信息（身份证、护照等）、地理位置（位置信息）、银行卡信息等。</span></div>

    <div class="text-offset-2">2.保障交易安全所必需的情形</div>
    <div class="text-offset-2">为提高您使用我们的网络运营平台时系统的安全性，更准确地预防网络安全风险和保护账户安全，您需要提供下述个人信息，包括但不限于：</div>
    <div class="text-offset-2">（1）终端电脑设备信息：包括但不限于浏览器、相关软件版本、显示器、操作系统等相关信息。</div>
    <div class="text-offset-2">（2）网站访问浏览信息：包括但不限于访问时间、时长、次数、页面、网络日志等。</div>
    <div class="text-offset-2">（3）流量来源信息：包括但不限于跳转至网络运营平台之前的外部页面、搜索引擎相关信息等。</div>
    <div class="text-offset-2">（4）<span class="importance">个人信息：手机号码、姓名、证件类型、身份证件信息（身份证、护照等）、会员信息、等。</span></div>
    <div class="text-offset-2">（5）授权合作伙伴取得您授权或依据法律共享的信息。</div>
    <div class="text-offset-2">如您同意授权提供，则上述信息由我们自动获取，无需您主动录入。</div>
    <div class="text-offset-2">（二）您使用附加功能须提供并授权我们使用个人信息的情形</div>
    <div class="text-offset-2">为给您提供更丰富更便捷的产品及服务，我们的网络运营平台以下主要附加功能需要使用您的个人信息。如果您拒绝提供并授权，您依然可以使用网络运营平台的核心功能接受服务，但无法获得附加功能对应的相关服务。</div>
    <div class="text-offset-2">这些附加业务功能包括但不限于：</div>
    <div class="text-offset-2">1．订单支付</div>
    <div class="text-offset-2">2．保单查询、电子保单下载</div>
    <div class="text-offset-2">3．批改新车车牌号码</div>
    <div class="text-offset-2">4．车险自助加保</div>
    <div class="text-offset-2">5．电子发票信息查询及下载</div>
    <div class="text-offset-2">6．隐私政策变更、服务升级</div>
    <div class="text-offset-2">7．活动提醒</div>
    <div class="text-offset-2">8．营销活动推广</div>
    <div class="text-offset-2">9．保险产品推介及营销</div>
    <div class="text-offset-2">10．短信及邮件类服务提醒</div>
    <div class="text-offset-2">11．个人设置</div>
    <div class="text-offset-2">12．保险销售从业人员及相关人员的管理</div>
    <div class="text-offset-2">13．开展数据分析和研究，改进我们的产品及服务</div>
    <div class="text-offset-2">为了提升您的产品及服务体验，您需要提供<span class="importance">姓名、证件类型、身份证件信息（身份证、护照等）、手机号码等个人信息、互动操作、注册时间、代理人考试时间、浏览及搜索记录、设备信息、地理位置（位置信息）、订单信息、车辆信息等，我们将提取您的浏览及搜索偏好、行为习惯等。</span>我们会对上述信息进行统计、分析，用以改善产品和服务、合理定价并推送适合的金融保险产品。</div>
    <div class="text-offset-2">（三）您授权我们从第三方查询和收集个人信息的情形</div>
    <div class="text-offset-2">为通过网络运营平台的上述核心及附加功能向您提供产品及服务，您需要授权我们在法律法规及监管规定允许的范围内，从中银保险内部查询和收集<span class="importance">您的投保人及被保险人、车主的姓名、证件类型、身份证件信息（身份证、护照等）、手机号、邮箱、会员信息【包括姓名、手机号、证件类型、身份证件信息（身份证、护照等）】等个人信息，从电子发票服务提供方处查询和收集您的姓名、证件类型、身份证件信息（身份证、护照等）等个人信息。</span></div>
    <div class="text-offset-2">（四）开启相关设备权限</div>
    <div class="text-offset-2">您需要在您的设备中向我们开启设备信息、地理位置（位置信息）、相机（摄像头）、相册（图片库）、传感器、麦克风等访问权限，以收集和使用上述核心及附加功能对应服务所需要的个人信息。您开启这些访问权限即代表您同意提供或授权我们可以收集和使用这些个人信息来实现上述功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集您的这些个人信息，也无法为您提供与这些授权所对应功能相关的服务。</div>
    <div class="text-offset-2">（五）<span class="importance">根据相关法律法规、监管要求及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息而无需另行征求您的授权同意：</span></div>
    <div class="text-offset-2">1．与国家安全、国防安全直接相关的；</div>
    <div class="text-offset-2">2．与公共安全、公共卫生、重大公共利益直接相关的；</div>
    <div class="text-offset-2">3．与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
    <div class="text-offset-2">4．紧急情况下出于维护您或其他个人的生命、财产等重大合法权益的；</div>
    <div class="text-offset-2">5．所收集的个人信息是您自行向社会公众公开的；</div>
    <div class="text-offset-2">6．从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</div>
    <div class="text-offset-2">7．根据您要求签订和履行合同所必需的；</div>
    <div class="text-offset-2">8．用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</div>
    <div class="text-offset-2">9．合理范围内为公共利益开展合法的新闻报道、舆论监督等行为所必需的；</div>
    <div class="text-offset-2">10．出于公共利益开展统计或学术研究所必需，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</div>
    <div class="text-offset-2">11．法律法规及监管要求规定的其他情形。</div>
    <div class="text-offset-2">（六）对您个人信息使用的规则</div>
    <div class="text-offset-2">1.我们会认真按照本隐私政策的约定使用您的个人信息。当我们要将您的个人信息用于本隐私政策未载明的其它用途时，或将基于特定目的收集而来的信息<span class="importance">用于其他目的时，我们会事先征求您的同意。</span></div>
    <div class="text-offset-2">2.在收集您的个人信息后，我们有可能通过技术手段对数据进行去标识化处理。经去标识化处理的信息将无法用来重新识别您的身份。根据法律规定，我们有权使用、共享已经去标识化的信息，开展数据分析等商业化应用。</div>
    <div class="text-offset-2">3.您在使用我们的产品及接受服务时所提供或授权我们查询收集的所有个人信息，将在您使用我们的产品及接受服务期间持续授权我们使用，除非您提交删除申请（法律法规或监管部门另有规定的除外）。</div>
    <div class="text-offset-2">4.当您使用产品和接受服务的过程中，需要使用手机等设备明确显示您的个人信息时，我们会采用包括匿名、部分信息采用符号替换等方式处理您的信息，以保护您的信息安全。</div>
    <div class="text-offset-2">5.对于网络运营平台的核心及附加功能所收集的敏感个人信息，我们将采用弹窗或独立授权协议等方式（原则上不影响用户投保流程体验）向您进行告知，并明确告知您拒绝提供或者拒绝同意将带来的影响，例如您将无法使用相应的核心功能或附加功能接受相关服务，以确保您在完全知情的基础上决定是否提供或授权我们查询、收集、共享您的敏感个人信息。</div>

    <div class="first-wrap">二、我们如何使用Cookie和同类技术</div>
    <div class="text-offset-2 importance">（一）Cookie</div>
    <div class="text-offset-2">为确保服务正常运转，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。借助于Cookie，网站能够存储您的偏好数据。我们不会将Cookie用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。</div>
    <div class="text-offset-2 importance">（二）Do Not Track（请勿追踪）</div>
    <div class="text-offset-2">很多网络浏览器均设有Do Not Track 功能，该功能可向网站发布Do Not Track请求。目前，主要互联网标准组织尚未设立相关政策来规定网站应如何应对此类请求。但如果您的浏览器启用了Do Not Track，那么我们的所有网站都会尊重您的选择。</div>

    <div class="first-wrap">三、我们如何共享、转让和公开披露您的个人信息</div>
    <div class="text-offset-2 importance">（一）共享和转让</div>
    <div class="text-offset-2">1．除非获得您的明确同意或授权，我们不会向其他任何公司、组织和个人共享或转让您的个人信息。</div>
    <div class="text-offset-2">2．如业务需要对外共享或转让您的个人信息，我们会向您告知共享或转让个人信息的目的、数据接收方的类型，并征得您的授权同意。涉及敏感个人信息的，我们还会告知敏感个人信息的类型、数据接收方的身份和数据安全能力，并征得您的明示授权同意。</div>
    <div class="text-offset-2">3．请您理解，我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</div>
    <div class="text-offset-2">4.根据法律法规和商业惯例，在合并、收购、资产转让等类似交易中，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</div>
    <div class="text-offset-2">5．在法律要求或允许的范围内，为了保护我们及其客户或社会公众的利益、财产或安全免遭损害而有必要提供您的个人信息给第三方。</div>
    <div class="text-offset-2">6．您的个人信息可能会在我们各分支机构进行共享。我们只会共享必要的个人信息，且这种共享受本隐私政策所声明目的的约束。一旦改变个人信息的处理目的，将再次征求您的授权同意。共享个人信息的范围将根据具体业务情况而定，如根据要求向金融监督管理部门报送统计信息时，可能在我们各分支机构共享您的个人身份信息以及车辆信息。</div>
    <div class="text-offset-2">7．为了向您提供更完善、优质的产品和服务，我们的某些服务将由合作方提供。我们可能会与合作方共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。同时，我们会与合作方签署严格的保密协定，要求他们严格按照我们的说明、本隐私政策以及其他任何相关的保密和采取安全措施来处理您的个人信息。我们将要求我们的合作方无权将共享的个人信息用于任何其他用途。如果您拒绝我们的合作方在提供服务时与我们共享我们收集的为提供服务所必须的您的个人信息，将可能导致您无法使用该服务。</div>
    <div class="text-offset-2 importance">（二）公开披露</div>
    <div class="text-offset-2">1．我们不会公开披露您的个人信息，法律、行政法规另有规定或者取得您同意的除外。</div>
    <div class="text-offset-2">如确需披露，我们会告知您披露个人信息的目的、类型；涉及敏感个人信息的还会告知敏感个人信息的内容，并事先征得您的明示同意。</div>
    <div class="text-offset-2">2．请您理解，在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</div>
    <div class="text-offset-2 importance">（三）征得授权同意的例外</div>
    <div class="text-offset-2 importance">根据相关法律法规及监管要求、国家标准，以下情形中，我们可能会共享、转让、公开披露用户信息无需事先征得您授权同意：</div>
    <div class="text-offset-2">1．与国家安全、国防安全直接相关的；</div>
    <div class="text-offset-2">2．与公共安全、公共卫生、重大公共利益直接相关的</div>
    <div class="text-offset-2">3．与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
    <div class="text-offset-2">4．出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；</div>
    <div class="text-offset-2">5．您自行向社会公众公开的个人信息；</div>
    <div class="text-offset-2">6．从合法公开披露的信息中收集的用户信息，如合法的新闻报道、政府信息公开等渠道；</div>
    <div class="text-offset-2">7.其他法律、行政法规规定的情形。</div>

    <div class="first-wrap">四、我们如何存储和保护您的个人信息</div>
    <div class="text-offset-2 importance">（一）存储</div>
    <div class="text-offset-2">1．我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。</div>
    <div class="text-offset-2">2．如您没有提出删除您个人信息的请求，我们会在法律法规及监管规定允许的范围内永久保留您的个人信息；如您提出删除您的个人信息的请求，我们会对您的个人信息进行删除处理。</div>
    <div class="text-offset-2 importance">（二）保护</div>
    <div class="text-offset-2">1．我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如：我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</div>
    <div class="text-offset-2">2．如我们提供的全部或部分车险网络平台业务停止运营，我们相关产品或服务将通过公告等形式向您进行告知，同时停止相关产品或服务对您个人信息的收集等操作，保护您的个人信息安全。如因技术故障、网络攻击、自然灾害及事故、人为因素等各种原因造成全部或部分车险网络平台业务中断，我们将采取应急处置和恢复措施予以应对，尽快恢复服务。</div>
    <div class="text-offset-2">3．我们会采取一切合理可行的措施，确保不收集无关的个人信息。</div>
    <div class="text-offset-2">4．请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现我们无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码和安全工具，协助我们保证您的账户及个人信息安全。</div>
    <div class="text-offset-2">5．如发生个人信息安全事件，我们将按照法律法规的要求，及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，我们还将依据监管规定，上报个人信息安全事件处置情况。</div>

    <div class="first-wrap">五、我们如何实现您在个人信息处理活动中的权利</div>
    <div class="text-offset-2">按照中华人民共和国相关的法律法规和监管规定，我们保障您在个人信息处理活动中的权利：</div>
    <div class="text-offset-2 importance">（一）查询、复制您的个人信息</div>
    <div class="text-offset-2">您有权向我们查询、复制您的个人信息，有法律、行政法规规定应当保密或者不需要告知的情形的，可以不向您告知。</div>
    <div class="text-offset-2 importance">（二）访问、更正及更新您的个人信息</div>
    <div class="text-offset-2">为保护您的信息安全，您有权通过我们车险网络平台访问、更正、更新您的个人信息，法律法规另有规定的除外。</div>
    <div class="text-offset-2 importance">（三）删除您的个人信息</div>
    <div class="text-offset-2">在以下情形中，您可以向我们提出删除个人信息的请求：</div>
    <div class="text-offset-2">1．如果我们处理个人信息的行为违反法律法规；</div>
    <div class="text-offset-2">2．如果我们收集、使用您的个人信息，却未征得您的同意；</div>
    <div class="text-offset-2">3．如果我们处理个人信息的行为违反了与您的约定；</div>
    <div class="text-offset-2">4．如果您不再使用我们的产品或服务，或您注销了账户；</div>
    <div class="text-offset-2">5．如果我们不再为您提供产品或服务。如我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</div>
    <div class="text-offset-2 importance">（四）个人信息主体解除服务</div>
    <div class="text-offset-2 importance">请您注意，您可随时取消授权或删除其个人信息内容，无需我们回应但要承担相应取消授权我们使用个人信息的后果。<span class="normal">您取消关注中银保险微信公众号或其他途径取消授权的操作不会终止本协议。当您取消关注中银保险微信公众号或取消授权后，我们将不再查询、收集、共享或公开披露您的相应个人信息。但根据本隐私政策第一部分，您将无法使用相应的业务功能接受服务，同时根据《保险法》《反洗钱法》等法律法规、监管规定我们还将继续保存您的相关个人信息。您取消授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</span></div>
    <div class="text-offset-2 importance">（五）响应您的上述请求</div>
    <div class="text-offset-2">为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</div>
    <div class="text-offset-2">尽管有上述约定，但按照法律法规要求，如涉及以下情形我们将可能无法响应您的请求：</div>
    <div class="text-offset-2">1．与国家安全、国防安全相关的；</div>
    <div class="text-offset-2">2．与公共安全、公共卫生、重大公共利益相关的；</div>
    <div class="text-offset-2">3．与犯罪侦查、起诉、审判和判决执行等相关的；</div>
    <div class="text-offset-2">4．有充分证据表明您存在主观恶意或滥用权利的；</div>
    <div class="text-offset-2">5．响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</div>
    <div class="text-offset-2">6．涉及我们商业秘密的；</div>
    <div class="text-offset-2">7．为履行反洗钱和制裁规定；</div>
    <div class="text-offset-2">8. 其他危害国家安全、公共利益的情形。</div>

    <div class="first-wrap">六、我们如何处理未成年人信息</div>
    <div class="text-offset-2">如果没有监护人的同意，未成年人不得使用中银保险车险网络平台的相关功能服务。如您为未成年人，请您的监护人仔细阅读本隐私政策，并在征得您的监护人同意的前提下使用我们的服务或向我们提供信息。我们只会在法律法规及监管要求允许或者保护未成年人所必要的情况下使用、对外提供此信息。</div>

    <div class="first-wrap">七、本隐私政策的适用以及更新</div>
    <div class="text-offset-2">1．我们保留不时更新或修改本隐私政策的权利。本隐私政策适用于中银保险车险及关联意外险客户。未经您明确同意，我们不会减少您按照本隐私政策所应享有的权利。我们通过推送通知、弹窗形式、官网公告通知等合理方式通知您，以便您能及时了解本隐私政策所做的任何变更（包括业务功能变更、使用目的变更、个人信息保护相关负责人联络方式变更等情形）。</div>
    <div class="text-offset-2">2．对于重大变更，视具体情况我们可能还会提供更为显著的通知说明本隐私政策具体变更内容。重大变更包括但不限于：</div>
    <div class="text-offset-2">（1）我们的服务模式和业务形态发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
    <div class="text-offset-2">（2）个人信息共享、转让或公开披露的主要对象发生变化；</div>
    <div class="text-offset-2">（3）您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
    <div class="text-offset-2">（4）我们负责处理个人信息安全的联络方式及投诉渠道发生变化；</div>
    <div class="text-offset-2">（5）个人信息安全影响评估报告表明存在高风险时。</div>
    <div class="text-offset-2">3．若您不同意修改后的隐私政策，您有权并应立即停止使用我们产品和服务。如果您勾选同意修改后的隐私政策并继续使用我们产品和服务，则视为您接受我们对本隐私政策相关条款所做的修改。</div>

    <div class="first-wrap">八、如何联系我们</div>
    <div class="text-offset-2">如您对本隐私政策有任何疑问、意见或建议，可以通过拨打我们<a
      href="tel:95566"
      style="color: #c0233f"
    >95566</a>客服热线或到我们各营业网点咨询或反映。受理您的问题后，我们会及时、妥善处理。一般情况下，我们将在15天内给予答复。如果您认为我们的个人信息处理行为损害了您的合法权益，您也可向有关监管部门或者行业协会进行反映。</div>
    <div class="text-offset-2">请您在点击“同意”之前仔细阅读本隐私政策，确保对其内容及相应法律后果已全部知晓并充分理解。您点击“同意”并确认提交即视为您接受本隐私政策，我们将按照相关法律法规及本隐私政策来合法使用和保护您的个人信息。</div>

  </div>
</template>
<script>
export default {
  name: 'Privacy',
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
$indent: 20px;
.text-offset-2 {
  text-indent: $indent;
}

.boci-privacy-wrap {
  min-height: 100vh;
  color: #383838;
  font-size: 16px;
  padding: 12px;
  padding-bottom: 24px;
  line-height: 24px;

  .title-wrap {
    font-size: 20px;
    font-weight: 500;
    width: 100%;
    text-align: center;
    margin-top: 24px;
  }

  .top-space{
     margin-top: 24px;
    //  margin-bottom: 32px;
  }

  .importance {
    font-weight: 500;
  }

  .normal {
    font-weight: 400;
  }

  .first-wrap {
    font-weight: 500;
    margin-top: 12px;
    text-indent: $indent;
  }
}

</style>
